import { CREATE_GUEST_USER, CREATE_GUEST_USER_SUCCESS, CREATE_GUEST_USER_ERROR, CREATE_GUEST_USER_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateGuestUser = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_GUEST_USER:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_GUEST_USER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_GUEST_USER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_GUEST_USER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateGuestUser;
